import { MessageCircle } from "lucide-react";

const WHATSAPP_NUMBER = "351960448841";

export const WhatsAppButton = ({ lang }) => {
  const messages = {
    pt: "Olá! Tenho interesse em criar um website profissional para o meu consultório médico. Gostaria de saber mais sobre os vossos serviços e condições.",
    en: "Hello! I'm interested in creating a professional website for my medical practice. I'd like to learn more about your services and pricing."
  };

  const handleClick = () => {
    // Google Ads Conversion Tracking
    if (typeof gtag !== 'undefined') {
      gtag('event', 'conversion', {'send_to': 'AW-17709544469/BvIuCObJzoUcEJXoyPxB'});
    }
    const message = encodeURIComponent(messages[lang] || messages.pt);
    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${message}`, "_blank");
  };

  return (
    <button
      onClick={handleClick}
      data-testid="whatsapp-float-btn"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-[#25D366] hover:bg-[#20BA5C] rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 group"
      aria-label="Contact via WhatsApp"
    >
      <MessageCircle className="w-7 h-7 text-white fill-white" />
      <span className="absolute right-full mr-3 px-3 py-2 bg-[#1A1A1A] text-white text-sm rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap pointer-events-none">
        {lang === "en" ? "Chat on WhatsApp" : "Falar no WhatsApp"}
      </span>
    </button>
  );
};

export default WhatsAppButton;
